import { record } from "@pomle/shapes";
import { boolean } from "./validators";

export type FeaturePreferences = {
  type: "feature_preferences/v1";
  roomScanWarningEnabled: boolean;
  dermaQrCodeEnabled: boolean;
  checkoutFlowEnabled: boolean;
  pressureRetestAlertsEnabled: boolean;
  bloodDrawStepEnabled: boolean;
};

type FeaturePreferenceStorage = {
  roomScanWarningEnabled: boolean;
  dermaQrCodeEnabled: boolean;
  checkoutFlowEnabled: boolean;
  pressureRetestAlertsEnabled: boolean;
  bloodDrawStepEnabled: boolean;
};

const defaultFeaturePreference: FeaturePreferences = {
  type: "feature_preferences/v1",
  roomScanWarningEnabled: false,
  dermaQrCodeEnabled: false,
  checkoutFlowEnabled: false,
  pressureRetestAlertsEnabled: false,
  bloodDrawStepEnabled: false,
};

export const featurePreferenceStorageRecord = record<FeaturePreferenceStorage>({
  roomScanWarningEnabled: boolean(
    defaultFeaturePreference.roomScanWarningEnabled
  ),
  dermaQrCodeEnabled: boolean(defaultFeaturePreference.dermaQrCodeEnabled),
  checkoutFlowEnabled: boolean(defaultFeaturePreference.checkoutFlowEnabled),
  pressureRetestAlertsEnabled: boolean(
    defaultFeaturePreference.pressureRetestAlertsEnabled
  ),
  bloodDrawStepEnabled: boolean(defaultFeaturePreference.bloodDrawStepEnabled),
});

export function createFeaturePreferences(
  preferences: FeaturePreferenceStorage | undefined
): FeaturePreferences {
  if (!preferences) {
    return { ...defaultFeaturePreference };
  }

  return {
    type: "feature_preferences/v1",
    ...preferences,
  };
}
